<template>
  <h1 class="title-header">
    <slot />
  </h1>
</template>

<style scoped>
.title-header {
  position: relative;
  color: var(--funarpen-navy);
  font-size: clamp(1.8rem, 3vw, 2.7rem);
  font-weight: 900;
  line-height: 1.08;
  border-bottom: 1px solid rgba(8, 47, 73, 0.12);
  padding-bottom: 1rem;
  margin-bottom: clamp(1.8rem, 4vw, 2.8rem);
  user-select: none;
  word-break: break-word;
  hyphens: auto;
  display: block;
  letter-spacing: 0;
}

.title-header::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: clamp(84px, 11vw, 140px);
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--funarpen-gold), var(--funarpen-blue-2));
}
</style>
